import React from 'react';
import glassdoorLogo from '../../assets/images/glassdoor-logo.png';
import workplacesLogo from '../../assets/images/workplaces-logo.png'
import instagramColored from '../../assets/images/instagram-colored-icon.png'
import linkedinColored from '../../assets/images/linkedin-colored-icon.png'

const JoinTheTribe = () => {
  return ( 
    <div className="join-the-tribe">
      <div className="row">
        <div className="col-lg-9">
          <p className="text-primary fs-95 font-weight-thin join">Join the<br></br>SmartTribe</p>
          <div className="row mt-5 pt-5 help">
            <div className="col-md-4">
              <p className="text-gray fs-14 help">Help us make the world safer - one ride<br></br> at a time</p>
            </div>
            <div className="col-md-3">
              <img src={glassdoorLogo} alt="Glassdoor Logo" />
            </div>
            <div className="col-md-2 join-image">
              <img src={workplacesLogo} alt="Workplaces Logo" />
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="peek-in text-center">
            <p className="peekin-text fs-18 font-weight-bold">Peek in</p>
            <div className="peekin-icons">
              <div>
                <img src={instagramColored} alt="Instagram" />
              </div>
              <div>
                <img src={linkedinColored} alt="Linkedin" className="linkedin-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>      
    </div>
   );
}
 
export default JoinTheTribe;